// 自动超时退出（纯时间戳方案，稳定不失效）
const EXPIRE_TIME = 30 * 60 * 1000; // 30分钟测试，正式用 10*60*1000

// 登录成功时记录时间
export function setLoginTime() {
  localStorage.setItem("loginTime", Date.now());
}

// 检查是否超时
export function checkTimeout() {
  const loginTime = localStorage.getItem("loginTime");
  if (!loginTime) return true;
  return Date.now() - loginTime > EXPIRE_TIME;
}

// 统一退出方法（清空所有信息）
export function doLogout() {
  localStorage.removeItem("Token");
  localStorage.removeItem("username");
  localStorage.removeItem("password");
  localStorage.removeItem("authNamelist");
  localStorage.removeItem("userName");
  localStorage.removeItem("loginTime");

  // 用 Element UI 美观弹窗
  import("element-ui").then(({ Message }) => {
    Message({
      message: "登录超时，请重新登录",
      type: "warning",
      duration: 2000,
      onClose: () => {
        window.location.href = "/login";
      },
    });
  });
}



// WEBPACK FOOTER //
// ./src/utils/autoLogout.js